module.exports = __webpack_public_path__ + "static/img/logo.86504693.png";